import AppCountriesIndex from "./country.vue";
import AppCountriesList from "./list/list.vue";
import AppCountriesItem from "./item/item.vue";

const routes = [
  {
    path: "/country",
    component: AppCountriesIndex,
    meta: {
      auth: {
        roles: "country.index",
        redirect: { name: "auth.login" },
        forbiddenRedirect: "/403"
      }
    },
    children: [
      {
        path: "",
        name: "country.index",
        component: AppCountriesList,
        meta: {
          auth: {
            roles: "country.index",
            redirect: { name: "auth.login" }
          }
        }
      },
      {
        path: "create",
        name: "country.create",
        component: AppCountriesItem,
        meta: {
          auth: {
            roles: "country.create",
            redirect: { name: "country.index" }
          }
        }
      },
      {
        path: ":id",
        name: "country.edit",
        component: AppCountriesItem,
        meta: {
          auth: {
            roles: "country.update",
            redirect: { name: "country.index" }
          }
        }
      }
    ]
  }
];

export default routes;
